import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import AuthApp from './App';
import EmailVerificationResult from './EmailVerificationResult';

function AppRouter() {
  return (
    <Router>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          scope: "openid profile email",
        }}
      >
        <Routes>
          <Route path="/email-verification-result" element={<EmailVerificationResult />} />
          <Route path="/" element={<AuthApp />} />
          <Route path="*" element={<AuthApp />} />
        </Routes>
      </Auth0Provider>
    </Router>
  );
}

export default AppRouter;
